var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3337 13C11.3337 12.0696 11.3337 11.6044 11.2188 11.2259C10.9603 10.3736 10.2934 9.70669 9.44109 9.44816C9.06256 9.33333 8.59737 9.33333 7.66699 9.33333H4.33366C3.40328 9.33333 2.9381 9.33333 2.55956 9.44816C1.7073 9.70669 1.04035 10.3736 0.781819 11.2259C0.666992 11.6044 0.666992 12.0696 0.666992 13M9.00033 4C9.00033 5.65685 7.65718 7 6.00033 7C4.34347 7 3.00033 5.65685 3.00033 4C3.00033 2.34315 4.34347 1 6.00033 1C7.65718 1 9.00033 2.34315 9.00033 4Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserOutline);
export default __webpack_public_path__ + "static/media/icon-user-outline.ca4e15332c35f68af8238627082afae5.svg";
export { ForwardRef as ReactComponent };